import { render, staticRenderFns } from "./Internet.vue?vue&type=template&id=05f6d62c&scoped=true"
import script from "./Internet.vue?vue&type=script&lang=js"
export * from "./Internet.vue?vue&type=script&lang=js"
import style0 from "./Internet.vue?vue&type=style&index=0&id=05f6d62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f6d62c",
  null
  
)

export default component.exports